module.exports = __webpack_public_path__ + "static/media/icon_3.6e625105.svg";